import React, { useState } from "react";
import ReactDOM from "react-dom";
import Footer from "./Footer";
import WDictionary from "./WDictionary";
import RDictionary from "./RDictionary";
import Photos from "./Photos";
import axios from "axios";
import randomWords from "random-words";
import "./index.css";

function App() {
  let [currentWord, changeWord] = useState(" ");
  let [wordInfo, setInfo] = useState({ ready: false });
  let [otherInfo, setOther] = useState({});
  let [choseWord, chooseWord] = useState(" ");
  let [photos, setPhotos] = useState(null);
  function findData() {
    const dapiKey = `10xpkky0qwi62czwcbne66ms44k7gerylxqab7ytlr7vfyuk4`;
    const dapiURL = `https://api.wordnik.com/v4/word.json/${currentWord}/definitions?limit=5&includeRelated=false&useCanonical=false&includeTags=false&api_key=${dapiKey}`;
    const tapiURL = `https://api.dictionaryapi.dev/api/v2/entries/en_US/${currentWord}`;
    axios.get(dapiURL).then(findWord);
    axios.get(tapiURL).then(findE);
    const photosAPI =
      "563492ad6f91700001000001895b12a1c64148a5a4713507ee5bc2d9";
    let photosURL = `https://api.pexels.com/v1/search?query=${currentWord}&per_page=12`;
    const header = { Authorization: `Bearer ${photosAPI}` };
    axios.get(photosURL, { headers: header }).then(showPhotos);
  }

  function showPhotos(response) {
    setPhotos(response.data.photos);
  }

  function findWord(response) {
    setInfo({
      information: response.data,
      source: "W",
      ready: true,
    });
    chooseWord(currentWord);
  }
  function findE(response) {
    setOther({
      phonetics: response.data[0].phonetics[0],
      syn: response.data,
    });
  }

  function handleSearch(event) {
    event.preventDefault();
    findData();
  }

  function updateWord(event) {
    event.preventDefault();
    changeWord(event.target.value.trim().toLowerCase());
  }
  function findRandom(response) {
    //console.log(response.data);
    setInfo({
      information: response.data,
      source: "R",
      ready: true,
      phonetics: response.data[0].phonetics[0],
      syn: response.data,
    });
  }

  function randomWord(event) {
    event.preventDefault();
    let randomWord = randomWords();
    // console.log(randomWord);
    const randomURL = `https://api.dictionaryapi.dev/api/v2/entries/en_US/${randomWord}`;
    axios.get(randomURL).then(findRandom);
    chooseWord(randomWord);
    const photosAPI =
      "563492ad6f91700001000001895b12a1c64148a5a4713507ee5bc2d9";
    let photosURL = `https://api.pexels.com/v1/search?query=${randomWord}&per_page=12`;
    const header = { Authorization: `Bearer ${photosAPI}` };
    axios.get(photosURL, { headers: header }).then(showPhotos);
  }
  if (wordInfo.ready && wordInfo.source === "W") {
    return (
      <div className="background">
        <div className="insideApp">
          <section>
            <form onSubmit={handleSearch}>
              <input
                type="search"
                autoFocus={true}
                placeholder="Search for a word..."
                onChange={updateWord}
              />
            </form>
            <button onClick={randomWord} className="randomWord">
              Random Word
            </button>
          </section>
          <WDictionary
            wordInfo={wordInfo}
            choseWord={choseWord}
            otherInfo={otherInfo}
          />
          <Photos photos={photos} alt={choseWord} />
          <Footer />
        </div>
      </div>
    );
  } else if (wordInfo.ready && wordInfo.source === "R") {
    return (
      <div>
        <div className="insideApp">
          <section>
            <form onSubmit={handleSearch}>
              <input
                type="search"
                autoFocus={true}
                placeholder="Search for a word..."
                onChange={updateWord}
              />
            </form>
            <button onClick={randomWord} className="randomWord">
              Random Word
            </button>
          </section>
          <RDictionary wordInfo={wordInfo} choseWord={choseWord} />
          <Photos photos={photos} alt={choseWord} />
          <Footer />
        </div>
      </div>
    );
  } else {
    return (
      <div className="background">
        <div className="insideApp">
          <section>
            <form onSubmit={handleSearch}>
              <input
                type="search"
                autoFocus={true}
                placeholder="Search for a word..."
                onChange={updateWord}
              />
            </form>
            <button className="randomWord" onClick={randomWord}>
              Random Word
            </button>
          </section>
          <Footer />
        </div>
      </div>
    );
  }
}

const rootElement = document.getElementById("root");
ReactDOM.render(<App />, rootElement);
